/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![ItalicIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAABJklEQVR4nN2VP0oDURDGt0shmFovoHXOkIUn7Px5kc1MiAewMlWwUbAU9AAxWKmV2OoFkhNoLx5CmwRUNnnZrN0+nEYHvmrg+zFf8U2S/PvJfLeFrHNk/aolktsoALCMapsvdRgFQFRE1vNSpPdrM3mo7oDkLE0PNiJD+jlAchoAn4i6nVgPkk4LALA8m5s7198Eklm44MIckFFvv8wfu21zAJCMA+DDOdcwByDra8j/0dw86/R2y3i8HpkDkGWwzj/fsQeQPoUqeDM3d841kOU9XHBlDgCv6SoeYOmYA5DlMgDmeZ437QGkLyH/ibm59/2tRbEtLzj5lVlRtcgyBJLjlZD1ptL119VdxrIXBSieRcxzAZZRFABI72qbk8yKdxoZ0h+cb8HN3f733kUFAAAAAElFTkSuQmCC)
 */
export const ItalicIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M8.87 2.31A.5.5 0 0 1 9.34 2h10.92c.36 0 .6.36.47.69l-.6 1.5a.5.5 0 0 1-.47.31h-4.28l-4.17 15h4.05c.36 0 .6.36.47.69l-.6 1.5a.5.5 0 0 1-.47.31H3.74a.5.5 0 0 1-.47-.69l.6-1.5a.5.5 0 0 1 .47-.31h4.28l4.17-15H8.74a.5.5 0 0 1-.47-.69l.6-1.5Z"
        className={colorClass}
      />
    </svg>
  );
};
